/*
  MENU ITEMS
  path - url path in browser to match active class to highlight item
  route name is the vue router route name
  admin true - only user with is_admin=1 will show menu
*/
export default [
    {
        title: "Home",
        routeName: "home",
        icon: "lni lni-home",
        paths: ["/home"],
        active: false,
    },

    {
        title: "Jobs",
        routeName: "jobs",
        icon: "lni lni-files",
        paths: ["/jobs"],
        active: false,
        permissions: [
            "Jobs enquiry",
            "Jobs booking",
            "Jobs repair",
            "Jobs allocation",
            "Jobs stores",
            "Jobs quotation",
            "Jobs quality control",
            "Jobs shipping",
            "Jobs despatching",            
            "Jobs parts requisition",
            "Jobs parts return",
            "Jobs device replace",
            "Jobs cancel",
            "Jobs RNR",
            "Jobs details update",
            "Jobs defray",
            "Jobs reassess"
        ],
        childVisible: false,
        children: [
            {
                title: "Enquiry",
                routeName: "jobs-enquiry",
                permissions: ["Jobs enquiry"],
            },
           
            {
                title: "Bookings",
                routeName: "jobs-booking",
                permissions: ["Jobs booking"],
            },
            {
                title: "Bookings - Bulk Upload",
                routeName: "jobs-booking-bulk",
                permissions: ["Jobs booking"],
            },
            {
                title: "Tech. Allocation",
                routeName: "jobs-awaiting-allocation",
                permissions: ["Jobs allocation"],
            },
            {
                title: "Assess & Repair",
                routeName: "jobs-repair",
                permissions: ["Jobs repair"],
            },
            {
                title: "Quotations",
                routeName: "jobs-quotations",
                permissions: ["Jobs quotation"],
            },
            {
                title: "Quality Control",
                routeName: "jobs-quality-control",
                permissions: ["Jobs quality control"],
            },
            {
                title: "Parts Requisition",
                routeName: "jobs-parts-requisition",
                permissions: ["Jobs parts requisition"],
            },
            {
                title: "Parts Return",
                routeName: "jobs-parts-return",
                permissions: ["Jobs parts return"],
            },
            {
                title: "Device Replace",
                routeName: "jobs-device-replace",
                permissions: ["Jobs device replace"],
            },
            {
                title: "Details Update",
                routeName: "jobs-update",
                permissions: ["Jobs details update"],
            },
            {
                title: "Reassess",
                routeName: "jobs-reassess",
                permissions: ["Jobs reassess"],
            },
            {
                title: "Cancellations",
                routeName: "jobs-cancel",
                permissions: ["Jobs cancel"],
            },
            {
                title: "Return Not Repaired",
                routeName: "jobs-rnr",
                permissions: ["Jobs RNR"],
            },
            {
                title: "Defray",
                routeName: "jobs-defray",
                permissions: ["Jobs defray"],
            },
        ],
    },

    {
        title: "Shipping",
        routeName: "shipping",
        icon: "lni lni-ship",
        active: false,
        paths: ["/couriers", "/shipping"],
        permissions: ["Manage couriers", "Jobs shipping"],
        childVisible: false,
        children: [
            {
                title: "Inbound: Await Waybill",
                routeName: "shipping-inbound-awaiting-waybill",
                permissions: ["Jobs shipping"],
            },
            {
                title: "Inbound - Transit",
                routeName: "shipping-inbound",
                permissions: ["Jobs shipping"],
            },
            {
                title: "Outbound: Await Waybill",
                routeName: "shipping-outbound-awaiting-waybill",
                permissions: ["Jobs shipping"],
            },

            {
                title: "Manifests - Courier Handoff",
                routeName: "shipping-manifests",
                permissions: ["Jobs shipping"],
            },
           
            {
                title: "Walk-in Handoff",
                routeName: "shipping-handoff",
                permissions: ["Jobs shipping"],
            },

            {
                title: "Outbound - Transit",
                routeName: "shipping-outbound",
                permissions: ["Jobs shipping"],
            },
            
            {
                title: "Couriers",
                routeName: "couriers",
                permissions: ["Jobs shipping"],
            },
        ],
    },

    {
        title: "Accounts",
        routeName: "accounts",
        icon: "lni lni-coin",
        paths: ["/clients", "/partners","/suppliers","/accounts"],
        permissions: ["Manage clients", "Manage partners", "Manage accounts",
        "Manage suppliers",],
        active: false,
        childVisible: false,
        children: [
            {
                title: "Partners",
                routeName: "partners",
                permissions: ["Manage partners"],
            },

            {
                title: "Clients",
                routeName: "clients",
                permissions: ["Manage clients"],
            },
            {
                title: "Suppliers",
                routeName: "suppliers",
                permissions: ["Manage suppliers"],
            },
            {
                title: "Accounts",
                routeName: "accounts",
                permissions: ["Manage accounts"],
            },
            {
                title: "Invoices",
                routeName: "accounts-invoices",
                permissions: ["Manage accounts"],
            },
            {
                title: "Payments",
                routeName: "accounts-payments",
                permissions: ["Manage accounts"],
            },
            {
                title: "Credits",
                routeName: "accounts-credits",
                permissions: ["Manage accounts"],
            },
            {
                title: "Debits",
                routeName: "accounts-debits",
                permissions: ["Manage accounts"],
            },
            
        ],
    },

    {
        title: "Inventory",
        routeName: "inventory",
        icon: "lni lni-dropbox",
        paths: [
            "/parts",
            "/bin-locations",
            "/goods-received",
            "/orders",
        ],
        permissions: [
            "Manage parts",
            "Manage goods received",
            "Manage orders",
            "Manage bin locations",
        ],
        active: false,
        childVisible: false,
        children: [
            {
                title: "Parts",
                routeName: "parts",
                permissions: ["Manage parts"],
            },

            {
                title: "Orders",
                routeName: "orders",
                permissions: ["Manage orders"],
            },
            
            {
                title: "Goods Received",
                routeName: "goods-received",
                permissions: ["Manage goods received"],
            },
            {
                title: "Adjustments",
                routeName: "parts-adjustments",
                permissions: ["Manage parts"],
            },
            {
                title: "Bin Locations",
                routeName: "bin-locations",
                permissions: ["Manage bin locations"],
            },
            {
                title: "Requisitions List",
                routeName: "parts-requisitions-list",
                permissions: ["Manage parts"],
            },
            {
                title: "Returns List",
                routeName: "parts-returns-list",
                permissions: ["Manage parts"],
            },
            
            {
                title: "Parts Upload",
                routeName: "parts-upload",
                permissions: ["Manage parts"],
            },
            
        ],
    },

    {
        title: "Messaging",
        routeName: "messaging",
        icon: "lni lni lni-wechat",
        paths: ["/messaging"],
        active: false,
        partner: false,
        permissions: ["Messaging"],
    },

    {
        title: "Reports & Stats",
        routeName: "reporting",
        icon: "lni lni-dashboard",
        permissions: ["reporting"],
        paths: ["/reporting"],
        active: false,
    },

   


    {
        title: "Device Setup",
        icon: "lni lni-laptop-phone",
        paths: [
            "/manufactures",
            "/device-types",
            "/device-models",
            "/symptoms",
            "/faults",
            "/actions",
            "/device-accessories",
            "/device-conditions",
            "/device-qc-checklists",
        ],
        active: false,
        permissions: [
            "Manage manufactures",
            "Manage device types",
            "Manage device models",
            "Manage device qc checklists",
            "Manage device conditions",
            "Manage device accessories",
            "Manage symptoms",
            "Manage faults",
            "Manage actions",
        ],
        childVisible: false,
        children: [
            {
                title: "Manufactures",
                routeName: "manufactures",
                permissions: ["Manage manufactures"],
            },
            {
                title: "Device Types",
                routeName: "device-types",
                permissions: ["Manage device types"],
            },
            {
                title: "Device Models",
                routeName: "device-models",
                permissions: ["Manage device models"],
            },

            {
                title: "Device QC Checklists",
                routeName: "device-qc-checklists",
                permissions: ["Manage device qc checklists"],
            },

            {
                title: "Accessories",
                routeName: "device-accessories",
                permissions: ["Manage device accessories"],
            },
            {
                title: "Conditions",
                routeName: "device-conditions",
                permissions: ["Manage device conditions"],
            },
            {
                title: "Symptoms",
                routeName: "symptoms",
                permissions: ["Manage symptoms"],
            },
            {
                title: "Faults",
                routeName: "faults",
                permissions: ["Manage faults"],
            },
            {
                title: "Actions",
                routeName: "actions",
                permissions: ["Manage actions"],
            },
        ],
    },

    {
        title: "System",
        icon: "lni lni-cogs",
        paths: ["/settings", "/companies", "parameters", "schemes"],
        active: false,
        permissions: ["Manage settings", "Manage companies", "Manage schemes"],
        childVisible: false,
        children: [
            {
                title: "Schemes",
                routeName: "schemes",
                permissions: ["Manage schemes"],
            },

            {
                title: "Parameters",
                routeName: "parameters",
                permissions: ["Manage companies"],
            },
            {
                title: "Company",
                routeName: "companies",
                permissions: ["Manage companies"],
            },
        ],
    },

    {
        title: "Users & Roles",
        icon: "lni lni-users",
        paths: ["/users", "/roles", "/user-logs"],
        active: false,
        permissions: ["Manage users", "Manage roles", "View user logs"],
        childVisible: false,
        children: [
            {
                title: "User Management",
                routeName: "users",
                permissions: ["Manage users"],
            },
            {
                title: "Roles Management",
                routeName: "roles",
                permissions: ["Manage roles"],
            },
            {
                title: "User Logs",
                routeName: "user-logs",
                permissions: ["View user logs"],
            },
        ],
    },

    {
        title: "Admin",
        icon: "lni lni-warning",
        paths: ["/admin"],
        active: false,
        admin: true,
        childVisible: false,
        children: [
            {
                title: "Horizon Interface",
                routeName: "horizon",
            },
            {
                title: "Telescope Interface",
                routeName: "telescope",
            },
        ],
    },


    //Partner Routes -Menu
    {
        title: "Job Enquiry",
        routeName: "partner-jobs-enquiry",
        icon: "lni lni  lni-keyword-research",
        paths: ["/partner-jobs-enquiry"],
        active: false,
        partner:true
    },
    {
        title: "Messages",
        routeName: "partner-messaging",
        icon: "lni lni lni-wechat",
        paths: ["/partner-messaging"],
        active: false,
        partner:true
    },
    {
        title: "Job Booking",
        routeName: "partner-jobs-booking",
        icon: "lni lni  lni-circle-plus",
        paths: ["/partner-jobs-booking"],
        active: false,
        partner:true
    },
    {
        title: "Quotations",
        routeName: "partner-quotations",
        icon: "lni lni  lni-calculator",
        paths: ["/partner-quotations"],
        active: false,
        partner:true
    },
    {
        title: "Account",
        routeName: "partner-account",
        icon: "lni lni lni-money-protection",
        paths: ["/partner-account"],
        active: false,
        partner:true
    },
 
    {
        title: "Reports",
        routeName: "partner-reports",
        icon: "lni lni lni-stats-up",
        paths: ["/partner-reports"],
        active: false,
        partner:true
    },
    
];
